import useFormatMessage from '@hooks/useFormatMessage'
import ErrorBase from '@components/ErrorBase'

/**
 * NotFound component displays an error message when the requested page is not found.
 *
 * @param {object} props - The component props.
 * @param {Error|string} props.error - The error object or message.
 * @param {function} props.resetErrorBoundary - Function to reset the error boundary.
 * @returns {JSX.Element} The NotFound component.
 */
export default function NotFound({ error, resetErrorBoundary }) {
  const formatMessage = useFormatMessage()

  return (
    <ErrorBase
      title={formatMessage('error.notFound.title')}
      subtitle={formatMessage('error.notFound.message')}
      code={404}
      error={error}
      reset={resetErrorBoundary}
    />
  )
}
